// The states the "Review Student Results" overlay draws an answer in. The
// Student Reports mapping decides each option's state and the session renderer
// paints it; neither imports the other, so the names live here once.
export const REVIEW_STATE = {
  CORRECT: "correct",
  HERS_INCORRECT: "hers-incorrect",
  OTHER: "other",
  // Show Answers unchecked: every option as it looked before anyone answered.
  NEUTRAL: "neutral",
};
